import { Navigate, Route } from 'react-router-dom';
import { PermissionGate } from '../components/common/PermissionGate.js';
import { RolesAccessPage } from '../lazyPages.js';

/* ===========================================================================
 * ROLES & ACCESS — the first route gated by a PERMISSION rather than a role
 * list. A fragment for the reason `approvalDoorRoutes.tsx` gives (App.tsx is
 * size debt behind a ratchet); splice it in as `{ACCESS_ROLE_ROUTES}`.
 *
 * The nav row in `navGroups.ts` carries the same `permission`, and
 * `routeGates.test.tsx` fails when a permission-gated nav row has no route
 * carrying that key.
 * ======================================================================== */
export const ACCESS_ROLE_ROUTES = (
  <>
    <Route
      path="settings/roles"
      element={
        <PermissionGate permission="settings.roles.view" fallback={<Navigate to="/" replace />}>
          <RolesAccessPage />
        </PermissionGate>
      }
    />
  </>
);
